import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './CartCount.module.scss';
import { Icon } from '../Icon';
export const CartCount = ({ value, onChange, size = 'md', minValue = 0, disabled = false, }) => {
    const subtractCount = () => {
        if (disabled)
            return;
        const next = Math.max(minValue, value - 1);
        if (next !== value)
            onChange(next);
    };
    const addCount = () => {
        if (disabled)
            return;
        onChange(value + 1);
    };
    const rootClasses = [
        styles.cartCount,
        styles[`cartCount--${size}`],
        disabled ? styles['cartCount--disabled'] : '',
    ]
        .filter(Boolean)
        .join(' ');
    const decrementDisabled = disabled || value <= minValue;
    return (_jsxs("div", { className: rootClasses, children: [_jsx("button", { type: "button", className: styles.cartCount__minus, onClick: subtractCount, disabled: decrementDisabled, "aria-label": "Decrease quantity", children: _jsx(Icon, { faIconName: "fa-solid fa-minus" }) }), _jsx("div", { className: styles.cartCount__count, children: value }), _jsx("button", { type: "button", className: styles.cartCount__plus, onClick: addCount, disabled: disabled, "aria-label": "Increase quantity", children: _jsx(Icon, { faIconName: "fa-solid fa-plus" }) })] }));
};
